import React from "react";
import Store from "../store/store";
import { getAllUsers } from "../store/store";
import { observer } from "mobx-react";
import axios from "axios";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Modal from "@material-ui/core/Modal/Modal";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { IRole } from "../parametersRoles/interfaces/IRole";
import Spinner from "../Spinner/Spinner";
import { IUser } from "./interfaces/IUser";
const styles = require("./styles/listUsers_styles.module.scss");
const modal = require("../../styles/modal.scss");

interface IModal {
  open?: boolean;
  id?: number;
  loading: {
    modal: boolean;
    deleteButton: boolean;
  },
  error: {
    role: boolean;
    gedModal: boolean;
  },
  roleAssociatedToUser: IRole[];
  groupAssociatedToUser: IUser[];
  modalReactiv: {
    open: boolean;
    loadingReactivButton: boolean;
  };
}

@observer
export default class ParametersUser extends React.Component<RouteComponentProps<any>, IModal> {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      id: null,
      modalReactiv: {
        open: false,
        loadingReactivButton: false
      },
      loading: {
        modal: false,
        deleteButton: false
      },
      error: {
        role: false,
        gedModal: false
      },
      roleAssociatedToUser: [],
      groupAssociatedToUser: [],
    };
    getAllUsers();
  }



  componentDidMount() {
  }

  public toolbox = (cell: any, row: IUser) => {
    return (
      <div className={styles.listActionContainer}>
        {
          row.user_status == true ?
            <React.Fragment>
              <div className={styles.iconEdit} onClick={() => this.editRow(row)} title="Modifier"><Icon style={{ fontSize: 20 }}>mode_edit</Icon></div>
              <div className={styles.iconEdit} onClick={() => this.modalOpen(row.id, row.typeUserLydoc)} title="Désactiver"><Icon style={{ fontSize: 20 }}>block</Icon></div>
            </React.Fragment>
            :
            <React.Fragment>
              <div className={styles.iconEdit} onClick={() => this.editRow(row, true)} title="Voir"><Icon style={{ fontSize: 20 }}>visibility</Icon></div>
              {
                row.deleteParam != undefined && row.deleteParam != null && row.deleteParam.deleteType == "Manuel" ?
                  <div className={styles.iconEdit} onClick={() => this.modalReactivOpen(row.id)} title="Réactiver"><Icon style={{ fontSize: 20 }}>autorenew</Icon></div>
                  :
                  <div style={{ width: "20px" }} />
              }
            </React.Fragment>
        }
      </div>
    );
  }
  editRow = (row: any, viewMode?: boolean) => {
    Store.myUser = {
      id: row.id,
      civility: row.civility,
      lastname: row.lastname,
      firstname: row.firstname,
      matricule: row.matricule,
      email: row.email,
      login: row.login,
      password: row.password,
      id_service: row.id_terme_service, // john
      id_fonction: row.id_terme_fonction, // john
      id_profession: row.id_terme_profession, // john
      typeUserLydoc: row.typeUserLydoc,
      formRights: row.formRights,
      typeUser: row.typeUser,
      accessConsult: row.accessConsult, // john
      accessRef: row.accessRef, // john
      accessParam: row.accessParam,
      accessSignalement: row.accessSignalement,
      id_fonctionResponsable: { ActionReferent: [], InfoResponsable: [] }, // thomas
      id_professionResponsable: { ActionReferent: [], InfoResponsable: [] }, // Thomas
      id_serviceResponsable: { ActionReferent: [], InfoResponsable: [] }, // thomas
      id_riskResponsable: { ActionReferent: [], InfoResponsable: [] }, // thomas */
      user_status: row.user_status,
      date_inactivity: row.date_inactivity,
      deleteParam: row.deleteParam
    };
    Store.contextualmenu.content = viewMode == true ? "viewUser" : "editUser";
    Store.contextualmenu.open = "extended";
  };

  // Fonction appellée pour réactiver un utilisateur supprimé manuellement
  reactivUser = (id: number) => event => {
    this.setState({ modalReactiv: { ...this.state.modalReactiv, loadingReactivButton: true } }, () => {
      axios.post(Store.wsPath + "/1/users/reactivateUser", {
        id: id,
        idUserConnected: Store.userConnected.id
      }).then((response) => {
          this.modalClose();
          // Snack Bar
          Store.snackBar = {
            message: "L'utilisateur à bien été réactivé",
            error: false,
            open: true
          };
          getAllUsers();
      }).catch(error => {
        console.error("Error 'reactivUser' : ", error);
        // Snack Bar
        Store.snackBar = {
          message: "Une erreur c'est produite lors de la réactivation de l'utilisateur, veuillez réessayer",
          error: true,
          open: true
        };
        this.setState({ modalReactiv: {...this.state.modalReactiv, loadingReactivButton: false} });
      });
    });
  }

  deleteUser = (id: number) => event => {
    this.setState({ loading: { ...this.state.loading, deleteButton: true } }, () => {
      axios.post(Store.wsPath + "/1/users/SetStatusUserbyId", {
        id: id,
        idUserConnected: Store.userConnected.id
      }).then((response) => {
        if (response.status == 200) {
          this.modalClose();
          // Snack Bar
          Store.snackBar = {
            message: "L'utilisateur à bien été désactivé",
            error: false,
            open: true
          };
          getAllUsers();
        }
        else {
          // Snack Bar
          Store.snackBar = {
            message: "Une erreur c'est produite lors de la désactivation, veuillez réessayer",
            error: true,
            open: true
          };
          this.setState({ error: { ...this.state.error, role: true } });
        }
      }).catch(error => {
        console.error("Error 'deleteUser' : ", error);
        // Snack Bar
        Store.snackBar = {
          message: "Une erreur c'est produite lors de la désactivation, veuillez réessayer",
          error: true,
          open: true
        };
        this.setState({ error: { ...this.state.error, role: true } });
      });
    });
  };

  modalClose = () => {
    this.setState({ open: false, id: null, loading: { modal: false, deleteButton: false }, error: { role: false, gedModal: false }, roleAssociatedToUser: [], modalReactiv:{open:false, loadingReactivButton: false} });
  };

  // Fonction appelée pour ouvrir la modal de confirmation pour la réactivation d'un utilisateur supprimé
  modalReactivOpen = (id: number) => {
    this.setState({ modalReactiv: { open: true, loadingReactivButton: false }, id: id });
  }

  modalOpen = (id: number, userType: "ged" | "admin" | "all") => {
    this.setState({ open: true, id: id, loading: { deleteButton: false, modal: true } }, () => {
      let erreurGed: boolean = false;
      // On check si il est ged ou pas si il est pas ged on fait normal
      if (userType == "ged") {
        const allGedList = Store.allUsers.filter(user => user.typeUserLydoc == "ged" && user.user_status == true);

        // On regarde si il y a qu'un ged et si mon utilisateur n'est pas dans les geds, si il y est on affiche une erreur comme quoi on peut pas supprimé l'utilisateur car ged
        if (allGedList.length == 1 && allGedList.find(user => user.id == id) != undefined) {
          erreurGed = true;
        }
      }

      if (erreurGed) {
        this.setState({ loading: { ...this.state.loading, modal: false }, error: { role: false, gedModal: true } });
      }
      else {
        // On get les roles associés aux groupes
        axios.get(Store.wsPath + '/1/roles/getAllRoleByIdUser', {
          params: {
            idUser: id
          }
        }).then(responseRole => {
          axios.get(Store.wsPath + '/1/paramGroupes/getAllGroupForAnUser', {
            params: {
              idUser: id
            }
          }).then(responseGroup => {
            this.setState({ roleAssociatedToUser: responseRole.data, groupAssociatedToUser: responseGroup.data, loading: { ...this.state.loading, modal: false } });
          }).catch(error => {
            console.error("Error 'modalOpen' : ", error);
            Store.snackBar = {
              message: "Une erreur c'est produite, veuillez réessayer",
              error: true,
              open: true
            };
            this.setState({ loading: { ...this.state.loading, modal: false }, error: { role: true, gedModal: false } })
          });
        }).catch(error => {
          console.error("Error 'modalOpen' : ", error);
          Store.snackBar = {
            message: "Une erreur c'est produite, veuillez réessayer",
            error: true,
            open: true
          };
          this.setState({ loading: { ...this.state.loading, modal: false }, error: { role: true, gedModal: false } })
        });
      }
    });
  };

  addUser = () => {
    Store.myUser = Store.DefaultMyUser;
    Store.contextualmenu.content = "addUser";
    Store.contextualmenu.open = "extended";
  }
  public render() {
    const options = {
      sortIndicator: true,
      defaultSortName: 'firstname',
      noDataText: 'Aucun utilisateur à afficher',
      sizePerPage: 25,
    };

    return (
      <div className={styles.contentListUsers}>
        <div className={styles.usersTitle} style={{ background: Store.themeParam.backgroundPrimary }}><h5>Utilisateurs</h5></div>

        {(Store.userConnected.typeUserLydoc == "admin" || Store.userConnected.typeUserLydoc == "ged") && Store.authMode != "AAD" && Store.authMode != "AD" ?
          <div className={styles.buttonUserContent}>
            <Button
              onClick={this.addUser}
              variant="contained"
              color="primary"
            >
              <Icon>add</Icon> Ajouter un utilisateur
            </Button>
          </div>
          : ""}

        {Store.allUsers ?
          <div className={styles.usersContent}>
            <BootstrapTable
              multiColumnSearch
              data={Store.allUsers.filter(user => user.isGroup != true).map(user => {
                let right = "";
                if (user.typeUserLydoc == "ged") {
                  right = "GED";
                }
                else if (user.typeUserLydoc == "admin") {
                  right = "Administrateur";
                }
                else {
                  right = "Utilisateur";
                }
                user["typeUserLydocFormat"] = right;

                let statut = "Activé";
                if (user.user_status == false) {
                  statut = "Désactivé";
                }
                user["user_statusFormated"] = statut;

                return user;
              })}
              searchPlaceholder="Rechercher "
              search={true}
              pagination
              version="4"
              ref="table"
              options={options}
              striped
            >
              <TableHeaderColumn isKey={true} hidden dataField="id">
                Id
              </TableHeaderColumn>
              {/* <TableHeaderColumn headerAlign='center' dataAlign='center' width='10%' dataSort={true} dataField="civility">
                Civilité
              </TableHeaderColumn> */}
              <TableHeaderColumn headerAlign='center' dataAlign='center' dataSort={true} dataField="firstname">
                Prénom
              </TableHeaderColumn>
              <TableHeaderColumn headerAlign='center' dataAlign='center' dataSort={true} dataField="lastname">
                Nom
              </TableHeaderColumn>

              {/* <TableHeaderColumn headerAlign='center' dataAlign='center' dataSort={true} tdStyle={{ whiteSpace: 'normal' }} dataField="profession">
                Profession
                </TableHeaderColumn> */}
              {/* <TableHeaderColumn headerAlign='center' dataAlign='center' dataSort={true} tdStyle={{ whiteSpace: 'normal' }} dataField="service">
                Service
                
                </TableHeaderColumn> */}
              <TableHeaderColumn headerAlign='center' dataAlign='center' dataSort={true} dataField="email">
                Email
              </TableHeaderColumn>
              <TableHeaderColumn headerAlign='center' dataAlign='center' dataSort={true} dataField="login">
                Login
              </TableHeaderColumn>
              <TableHeaderColumn headerAlign='center' dataAlign='center' dataSort={true} dataField="typeUserLydocFormat">
                Droits
              </TableHeaderColumn>
              <TableHeaderColumn headerAlign='center' dataAlign='center' dataSort={true} dataField="user_statusFormated">
                Statut
              </TableHeaderColumn>
              {
                Store.userConnected.typeUserLydoc == "admin" &&
                  <TableHeaderColumn headerAlign='center' width={'80px'} dataField='user_status' tdStyle={{ padding: '0', verticalAlign: 'inherit' }} dataFormat={this.toolbox.bind(this)}>Actions</TableHeaderColumn>
              }
            </BootstrapTable>
          </div>
          : ""}

        <Modal
          open={this.state.open}
          className={modal.modal}
          onClose={this.modalClose}
        >
          <div className={modal.modalContent}>
            {
              this.state.error.role == true ?
                <React.Fragment>
                  <Typography variant="h5">
                    ⚠️Erreur
                  </Typography>
                  <br />
                  <Typography variant="subtitle2">
                    Une erreur est survenue, veuillez réesayer...
                  </Typography>
                  <br />
                  <div className={modal.modalButton}>
                    <Button
                      onClick={this.modalClose}
                      className={modal.button}
                      variant="contained"
                      color="secondary"
                    >
                      Fermer
                    </Button>
                  </div>
                </React.Fragment>
                :
                this.state.error.gedModal == true ?
                  <React.Fragment>
                    <Typography variant="h5">
                      ⚠️Erreur
                    </Typography>
                    <br />
                    <Typography variant="subtitle2">
                      Désactivation de l'utilisateur impossible, vous devez définir un nouveau GED avant de pouvoir le désactiver.
                    </Typography>
                    <br />
                    <div className={modal.modalButton}>
                      <Button
                        onClick={this.modalClose}
                        className={modal.button}
                        variant="contained"
                        color="secondary"
                      >
                        Fermer
                      </Button>
                    </div>
                  </React.Fragment>
                  :
                  this.state.loading.modal == true ?
                    <Spinner fullWidth={true} />
                    :
                    <React.Fragment>
                      <Typography variant="h5">
                        Désactivation
                      </Typography>
                      <br />
                      {
                        this.state.roleAssociatedToUser.length > 0 ?
                          <React.Fragment>
                            <Typography variant="subtitle2">
                              Cet utilisateur est associé aux rôles suivants :
                            </Typography>
                            <ul>
                              {
                                this.state.roleAssociatedToUser.map(role => {
                                  return (<li key={role.id + role.name}>{role.name}</li>);
                                })
                              }
                            </ul>
                            <Typography style={{ color: "red" }} variant="subtitle2">
                              Si vous désactivez cet utilisateur il sera également supprimé des rôles ci-dessus.
                            </Typography>
                            <Typography variant="subtitle2">
                              Vous devrez peut-être mettre à jour ces rôles avec un autre groupe/utilisateur.<br />
                              Tips: Vous pouvez aller mettre à jour les rôles ci-dessus avant de désactiver l'utilisateur.
                            </Typography>
                            <br />
                          </React.Fragment>
                          :
                          <React.Fragment />
                      }
                      {
                        this.state.groupAssociatedToUser.length > 0 ?
                          <React.Fragment>
                            <Typography variant="subtitle2">
                              Cet utilisateur fait parti des groupes suivants :
                            </Typography>
                            <ul>
                              {
                                this.state.groupAssociatedToUser.map(group => {
                                  return (<li key={group.id + group.firstname}>{group.firstname}</li>);
                                })
                              }
                            </ul>
                            <Typography style={{ color: "red" }} variant="subtitle2">
                              Si vous désactivez cet utilisateur il sera également supprimé des groupes ci-dessus.
                            </Typography>
                            <Typography variant="subtitle2">
                              Si l'un des groupes se retrouve vide, le groupe sera supprimé des rôles où il a été attribué.
                            </Typography>
                            <br />
                          </React.Fragment>
                          :
                          <React.Fragment />
                      }
                      <Typography variant="subtitle2">
                        Vous allez désactiver cet utilisateur. Êtes-vous sûr de cette action ?
                      </Typography>
                      <br />
                      <div className={modal.modalButton}>
                        <Button
                          onClick={this.modalClose}
                          className={modal.button}
                          variant="contained"
                          color="secondary"
                          disabled={this.state.loading.deleteButton}
                        >
                          Annuler
                        </Button>
                        <Button
                          className={modal.button}
                          onClick={this.deleteUser(this.state.id)}
                          variant="contained"
                          color="primary"
                          disabled={this.state.loading.deleteButton}
                        >
                          {
                            this.state.loading.deleteButton == true ?
                              <Spinner size={24} />
                              :
                              "Valider"
                          }
                        </Button>
                      </div>
                    </React.Fragment>
            }
          </div>
        </Modal>

        <Modal
          open={this.state.modalReactiv.open}
          className={modal.modal}
          onClose={this.modalClose}
        >
          <div className={modal.modalContent}>
            <Typography variant="h5">
              Réactivation de l'utilisateur
            </Typography>
            <br />
            <Typography variant="subtitle2">
              Vous allez réactiver cet utilisateur. Êtes-vous sûr de cette action ?
            </Typography>
            <br />
            <div className={modal.modalButton}>
              <Button
                onClick={this.modalClose}
                className={modal.button}
                variant="contained"
                color="secondary"
                disabled={this.state.modalReactiv.loadingReactivButton}
              >
                Annuler
              </Button>
              <Button
                className={modal.button}
                onClick={this.reactivUser(this.state.id)}
                variant="contained"
                color="primary"
                disabled={this.state.modalReactiv.loadingReactivButton}
              >
                {
                  this.state.modalReactiv.loadingReactivButton == true ?
                    <Spinner size={24} />
                    :
                    "Valider"
                }
              </Button>
            </div>
          </div>
        </Modal>

      </div>
    );
  }
}
